import { useState } from 'react';
import { CircleHelp } from 'lucide-react';
import { MouseTooltip } from 'components/ui/MouseTooltip';

interface HoraCertaKpiProps {
  label: string;
  value: number;
  className: string;
  helpText?: string;
}

export const HoraCertaKpi = ({
  label,
  value,
  className,
  helpText,
}: HoraCertaKpiProps) => {
  const [hover, setHover] = useState<{ x: number; y: number } | null>(null);

  return (
    <div className={`rounded-lg py-2.5 px-3 text-center ${className}`}>
      <span className="block text-xl font-GilroyBold">{value}</span>
      <span className="inline-flex items-center justify-center gap-1 text-xs font-semibold">
        {label}
        {helpText ? (
          <span
            role="img"
            aria-label={helpText}
            tabIndex={0}
            className="inline-flex cursor-help items-center rounded-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-current"
            onMouseMove={(event) =>
              setHover({ x: event.clientX, y: event.clientY })
            }
            onMouseLeave={() => setHover(null)}
            onFocus={(event) => {
              const rect = event.currentTarget.getBoundingClientRect();
              setHover({ x: rect.right, y: rect.bottom });
            }}
            onBlur={() => setHover(null)}
          >
            <CircleHelp size={12} aria-hidden="true" />
          </span>
        ) : null}
      </span>
      {helpText && hover ? (
        <MouseTooltip
          x={hover.x}
          y={hover.y}
          title={label}
          description={helpText}
        />
      ) : null}
    </div>
  );
};
